import { render, staticRenderFns } from "./ProfileNavbarItem.vue?vue&type=template&id=279fd35b&"
import script from "./ProfileNavbarItem.vue?vue&type=script&lang=js&"
export * from "./ProfileNavbarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports